import React, { useEffect, useState } from 'react'
import ActiveSubscription from './ActiveSubscription';
import SubscriptionFeeHistory from './SubscriptionFeeHistory';
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from '@mui/system';
import TabUnstyled, { tabUnstyledClasses } from '@mui/base/TabUnstyled';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import { buttonUnstyledClasses } from '@mui/base/ButtonUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabPanelUnstyled from '@mui/base/TabPanelUnstyled';
import Box from '@mui/material/Box';
import { CompaniesProvider } from '../../../store/companies-context';
import axios from "../../../utils/fvAxios";
import { getOrgId } from '../../../utils/Token';



const white = {
    50: '#fff',
    100: '#fff',
    200: '#fff',
    300: '#fff',
    400: '#fff',
    500: '#F2F4F7',
    600: '#030202',
    700: '#0059B2',
    800: '#fff',
    900: '#fff',
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  color: black;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  background-color: transparent;
  width: 100%;
  padding: 10px 5px;
  margin: 6px 6px;
  border: none;
  border-radius: 5px;
  display: flex;
  justify-content: center;

  &:hover {
    background-color: ${white[400]};
  }

  &:focus {
    color: #fff;
    border-radius: 3px;
    outline: 2px solid ${white[200]};
    outline-offset: 2px;
  }

  &.${tabUnstyledClasses.selected} {
    background-color: ${white[50]};
    color: ${white[600]};
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
  font-family: IBM Plex Sans, sans-serif;
  font-size: 0.875rem;
`;

const TabsList = styled(TabsListUnstyled)`
  min-width: 400px;
  background-color: ${white[500]};
  border-radius: 8px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: space-between;
`;

function SubscriptionFeeDetails() {
    const [value, setValue] = React.useState(0);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const [subscription, setsubscription] = useState([]);
    const [activeSubscription, setActiveSubscription] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const Org = getOrgId();

    useEffect(() => {
        axios.get("Prequalification/GetMembershipPaymentHistory?vendorId=" + Org + "&pageNumber=1&pageSize=100")
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.data == null) {
                        setsubscription([]);
                    } else {
                        setsubscription(res?.data?.data);
                    }
                }
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsLoading(false);
            });

        axios.get("Prequalification/GetActiveMembership?vendorId=" + Org)
            .then((res) => {
                if (res?.data?.responseCode == 100) {
                    if (res?.data?.data == null) {
                        setActiveSubscription(null);
                    } else {
                        setActiveSubscription(res?.data?.data);
                    }
                }
            }).catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            <Box sx={{ width: '100%' }}>
                <h1 className='mt-3' style={{ color: 'rgb(0,0,0)' }} >Subscription Fee Details</h1>

                <CompaniesProvider>
                    <TabsUnstyled value={value} onChange={handleChange} sx={{ backgroundColor: "#fff" }}>
                        <TabsList sx={{ width: "700px" }}>
                            <Tab >Active Subscription</Tab>
                            <Tab >Subscription Fee History</Tab>
                        </TabsList>
                        <TabPanel value={0} ><ActiveSubscription SubscriptionInfo={activeSubscription} /></TabPanel>
                        <TabPanel value={1} ><SubscriptionFeeHistory SubscriptionInfo={subscription} /></TabPanel>

                    </TabsUnstyled>
                </CompaniesProvider>
            </Box>
        </div>
    )
}

export default SubscriptionFeeDetails